import { ok } from 'neverthrow';
import { Assert } from '../../../utils';
import { FunctionTypingRule } from '../function-call';
import { satisfiesSignature } from './satisfies-signature';
import { Ty } from '../../../ty';
import _ from 'lodash';

const base = satisfiesSignature(['string', 'string'], 'string');

export const removePrefixSuffixTypingRule: FunctionTypingRule = (
  op,
  args,
  argAsts
) => {
  const [target, toRemove, ...rest] = args;

  Assert.assert(
    target !== undefined && toRemove !== undefined && rest.length === 0,
    'type checker checks arity'
  );

  if (target.ty.k === 'enum' && toRemove.ty.k === 'enum') {
    const [x, ...rest] = toRemove.ty.t;
    if (rest.length === 0) {
      let regex: RegExp;

      switch (op) {
        case 'remove_prefix':
          regex = new RegExp(`^${x}`);
          break;
        case 'remove_suffix':
          regex = new RegExp(`${x}$`);
          break;
        default:
          throw new Error(
            `Logic Error: ${op} is not valid for this typing rule`
          );
      }

      const nullable = target.nullable || toRemove.nullable;
      const ty: Ty.EnumType = {
        k: 'enum',
        t: _.uniq(target.ty.t.map((x) => x.replace(regex, ''))).sort(),
      };

      return ok({ ty, nullable, tags: [] });
    }
  }
  return base(op, args, argAsts);
};
